import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../../../stylesheets/pages/preauth/components/PreauthIntro.less';

const PreauthIntro = ({ userContext, children }) => (
  <div className="preauth-intro">
    <div className="preauth-intro-container">
      {userContext &&
        <div className="preauth-container">
          { children }
        </div>
      }
    </div>
  </div>
);

PreauthIntro.propTypes = {
  userContext: PropTypes.shape({}),
  children: PropTypes.element
};

const mapStateToProps = state => (
  {
    userContext: state.user.userContext,
  }
);

export default connect(
  mapStateToProps,
)(PreauthIntro);



/** WEBPACK FOOTER **
 ** ./src/pages/preauth/components/PreauthIntro.jsx
 **/